export default "/_next/static/videos/QR-menuuk-971d72ee909e91251fa495502ff9d579.mp4";